var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSdg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1898 22H7.81976C4.17976 22 2.00977 19.83 2.00977 16.19V7.82C2.00977 4.18 4.17976 2.01 7.81976 2.01H16.1898C19.8298 2.01 21.9998 4.18 21.9998 7.82V16.19C21.9998 19.83 19.8298 22 16.1898 22ZM10.7698 7.51C10.7698 6.84 10.2197 6.29 9.54974 6.29H7.09973C6.42973 6.29 5.87976 6.84 5.87976 7.51V16.49C5.87976 17.16 6.42973 17.71 7.09973 17.71H9.54974C10.2197 17.71 10.7698 17.16 10.7698 16.49V7.51ZM18.1198 11.35C18.1198 10.81 17.6798 10.37 17.1398 10.37H14.1998C13.6598 10.37 13.2197 10.81 13.2197 11.35V16.74C13.2197 17.28 13.6598 17.72 14.1998 17.72H17.1398C17.6798 17.72 18.1198 17.28 18.1198 16.74V11.35Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdg8);
export default __webpack_public_path__ + "static/media/sdg8.0fc1d8222f001b60426f5f73c386972c.svg";
export { ForwardRef as ReactComponent };